import { Box, Button, Flex, Input, InputGroup, InputLeftElement, Text } from "@chakra-ui/react";
import React from "react";
import { RiAddFill, RiSearch2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { openCreateGroup } from "../../../modules/admin-modules/models/Actions";
import { brandPalette } from "../../../constants/brandPalette";

const C = {
  primary: brandPalette.primary,
  secondary: brandPalette.accentDark,
  border: brandPalette.stone,
  muted: "rgba(30, 27, 23, 0.6)",
};

const SearchBar = ({ setAdd, setSelectedData, searchTerm, setSearchTerm }) => {
  const dispatch = useDispatch();
  const count = useSelector((state) => state.groups.count);

  return (
    <Box px={{ base: 4, md: 8 }} pt={6} pb={0} w="100%">
      <Flex
        align={{ base: "flex-start", md: "flex-end" }}
        justify="space-between"
        gap={6}
        flexDir={{ base: "column", md: "row" }}
        mb={6}
      >
        <Box>
          <Text
            fontSize={{ base: "32px", md: "54px" }}
            fontWeight="800"
            color={C.primary}
            fontFamily="'Amiri', 'Tajawal', sans-serif"
            lineHeight="1"
          >
            Groups
          </Text>
          <Text mt={3} color={C.muted} fontSize="sm" maxW="lg">
            Organize students into classes and link each group to subjects and schedules.
          </Text>
          <Text mt={2} fontSize="sm" fontWeight="700" color={C.secondary}>
            Total groups: {count ?? 0}
          </Text>
        </Box>

        <Flex align="center" gap={3} flexWrap="wrap">
          <Button
            borderRadius="full"
            leftIcon={<RiAddFill />}
            bg={C.primary}
            color={brandPalette.cream}
            px={8}
            py={6}
            fontWeight="800"
            _hover={{ bg: C.secondary }}
            _focus={{ boxShadow: "none" }}
            onClick={() => {
              setSelectedData({});
              setAdd(true);
              dispatch(openCreateGroup());
            }}
          >
            Add group
          </Button>
        </Flex>
      </Flex>

      <Box mb={6} maxW="520px">
        <InputGroup>
          <InputLeftElement pointerEvents="none" h="full">
            <RiSearch2Fill color="rgba(91, 13, 22, 0.5)" fontSize="18px" />
          </InputLeftElement>
          <Input
            placeholder="Search groups by name…"
            value={searchTerm}
            borderRadius="full"
            border="1px solid"
            borderColor={C.border}
            bg="var(--surface-raised)"
            pl={10}
            _focus={{ borderColor: C.primary, boxShadow: "0 0 0 1px rgba(91, 13, 22, 0.2)" }}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </Box>
    </Box>
  );
};

export default SearchBar;
